<template>
    <div class="wrapper">
        <!-- header -->
        <div class="header" style="position: absolute">
            <b-row no-gutters>
                <b-col cols="auto"></b-col>
                <b-col class="text-center">
                    <b-img :src="logo" alt="logo-moregiros" class="header-logo py-1"/>
                </b-col>
                <b-col cols="auto"></b-col>
            </b-row>
        </div>
        <!-- header ends -->

        <!-- Swiper intro -->
        <swiper ref="introduction" :options="swiperOptions" class="introduction pt-6">
            <template v-for="item in items">
                <swiper-slide class="overflow-hidden text-center">
                    <b-row no-gutters>
                        <b-col align-self="center" class="px-3">
                            <b-img :src="item.img" fluid center alt="moregiros" class="mx-100 my-3" style="max-height:360px;"/>
                            <b-row>
                                <b-container class="mb-5">
                                    <h4>{{ item.title }}</h4>
                                    <p>{{ item.text }}</p>
                                </b-container>
                            </b-row>
                        </b-col>
                    </b-row>
                </swiper-slide>
            </template>
            <!-- Add Pagination -->
            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
        <!-- Swiper intro ends -->

        <!-- login buttons -->
        <b-row align-h="center" class="mx-0 bottom-button-container">
            <b-col align-self="center">
                <b-button variant="default" size="lg" pill block class="shadow" to="/login">Iniciar Sesión</b-button>
            </b-col>
            <b-col align-self="center">
                <b-button variant="white" size="lg" pill block class="shadow" to="/register">Crear Cuenta</b-button>
            </b-col>
        </b-row>
        <!-- login buttons -->
    </div>
</template>

<script>
export default {
    name: "Introduction",
    data: () => ({
        logo: '/img/logo_header.png',
        items: [
            {
                img: '/img/screen-1.png',
                title: 'Crea tu envío',
                text: 'Selecciona el monto e ingresa los datos de tu destinatario solo una vez.'
            },
            {
                img: '/img/screen-2.png',
                title: 'Paga tu envío',
                text: 'Paga tu envío con transferencia, depósito o tarjeta de crédito/débito.'
            },
            {
                img: '/img/screen-3.png',
                title: 'Enviamos tu dinero',
                text: 'Comprobando tu pago, enviamos el dinero y tu destinatario lo recibe.'
            }
        ],
        swiperOptions: {
            speed:1000,
            direction: 'horizontal',
            pagination: {
                el: '.swiper-pagination',
                dynamicBullets: true
            },
            zoom: false,
            keyboard: {
                enabled: true,
                onlyInViewport: false
            },
            mousewheel: {
                invert: true
            },
            autoplay: {
                delay: 5000
            },
            loop: true
        }
    }),
    mounted() {
        this.$emit('loader');
    }
}
</script>

<style scoped>

</style>
